import { ReactElement } from 'react';
import styles from './AddressFieldAlertContent.module.scss';

interface iProps {
  title: string;
}

const AddressFieldAlertContentAccessible = ({ title }: iProps): ReactElement => (
  <>
    <p className={styles.msgWarning}>
      Your
      {` ${title.toLowerCase()} `}
      could not be automatically matched
    </p>
    <p>
      Please type in your
      {` ${title.toLowerCase()} `}
      manually below
    </p>
  </>
);

export default AddressFieldAlertContentAccessible;
